import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const CartPlusSvg = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5249 11.25H7.34625L7.57351 12.375H16.8936C17.4283 12.375 17.8247 12.8778 17.7062 13.4057L17.5146 14.2592C18.1636 14.5782 18.6111 15.2518 18.6111 16.0312C18.6111 17.1282 17.725 18.0156 16.6381 17.9998C15.6025 17.9847 14.7509 17.1339 14.723 16.0856C14.7077 15.513 14.9342 14.9941 15.3064 14.625H8.02695C8.38726 14.9824 8.61111 15.4802 8.61111 16.0312C8.61111 17.1497 7.69 18.0503 6.57396 17.9978C5.58299 17.9512 4.77705 17.1405 4.72497 16.1375C4.68476 15.3628 5.08733 14.6801 5.69896 14.3239L3.25983 2.25H0.833333C0.37309 2.25 0 1.87225 0 1.40625V0.84375C0 0.377754 0.37309 0 0.833333 0H4.39337C4.78924 0 5.13045 0.281988 5.20979 0.674648L5.52806 2.25H19.1663C19.7011 2.25 20.0974 2.75277 19.9789 3.28075L18.3375 10.5932C18.2513 10.9774 17.914 11.25 17.5249 11.25ZM14.1667 5.90625H12.5V4.5C12.5 4.18932 12.2513 3.9375 11.9444 3.9375H11.3889C11.082 3.9375 10.8333 4.18932 10.8333 4.5V5.90625H9.16667C8.85983 5.90625 8.61111 6.15807 8.61111 6.46875V7.03125C8.61111 7.34193 8.85983 7.59375 9.16667 7.59375H10.8333V9C10.8333 9.31068 11.082 9.5625 11.3889 9.5625H11.9444C12.2513 9.5625 12.5 9.31068 12.5 9V7.59375H14.1667C14.4735 7.59375 14.7222 7.34193 14.7222 7.03125V6.46875C14.7222 6.15807 14.4735 5.90625 14.1667 5.90625Z"
      fill="currentColor"
    />
  </svg>
);

export const CartPlus: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={CartPlusSvg} {...props} />
);

export default CartPlus;

CartPlus.displayName = "CartPlus";
